import { api } from "@/api/api";

export async function setLanguage(language: string): Promise<boolean> {
    try {
        const response = await fetch("/application/setlanguage", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ language }),
        });
        return response.ok;
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error("setLanguage failed:", err);
        return false;
    }
}

export type SupportedLanguage = {
    code: string;
    name: string;
    flag: string;
};

export async function getSupportedLanguages(): Promise<SupportedLanguage[]> {
    try {
        const response = await fetch("/application/getsupportedlanguages", {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        });

        if (!response.ok) return [];

        const result = await response.json();
        return Array.isArray(result) ? result : [];
    } catch (err) {
        console.error("getSupportedLanguages failed:", err);
        return [];
    }
}


export async function getGooglemapsAPIKey(): Promise<string | null> {
    try {
        const response = await fetch("/application/getgooglemapsapikey", {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        });

        if (!response.ok) return null;

        const result: unknown = await response.json();
        // Verwacht { apiKey: string }
        if (
            typeof result === "object" &&
            result !== null &&
            "apiKey" in result &&
            typeof (result as { apiKey: unknown }).apiKey === "string"
        ) {
            return (result as { apiKey: string }).apiKey;
        }
        return null;
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error("getGooglemapsAPIKey failed:", err);
        return null;
    }
}

export function setPageInfo(tabnaam: string, description: string) {
    try {
        document.title = tabnaam;

        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
            metaDescription.setAttribute(
                'content',
                description
            );
        } else {
            const meta = document.createElement('meta');
            meta.name = 'description';
            meta.content = description;
            document.head.appendChild(meta);
        }
    }
    catch (err) {
        // eslint-disable-next-line no-console
        console.error("setPageInfo failed:", err);
    }
    return null;
}